import React, { ChangeEvent, useCallback } from "react";
import { useAppDispatch } from "../../../../../state/store";
import { dateSearchAction } from "../../../../../state/usecase/admin/care_comment_analysis/actions";
import { useCareCommentAnalysisDataList } from "../../../../hooks/admin/care_comment_analysis/useCareCommentAnalysisDataList";

export const CareCommentAnalysisDataFilter = React.memo(function CareCommentAnalysisDataFilter() {
    const dispatch = useAppDispatch();

    const { registerDateStart, registerDateEnd } = useCareCommentAnalysisDataList();

    const handleRegisterDateStart = useCallback((e: ChangeEvent<HTMLDataElement>) => {
        const startDate = e.target.value;

        if (startDate && registerDateEnd && startDate > registerDateEnd) {
            return;
        }

        dispatch(dateSearchAction({
            registerDateStart: startDate,
            registerDateEnd: registerDateEnd
        }));
    }, [dispatch, registerDateEnd]);

    const handleRegisterDateEnd = useCallback((e: ChangeEvent<HTMLDataElement>) => {
        const endDate = e.target.value;

        if (registerDateStart && endDate && registerDateStart > endDate) {
            return;
        }

        dispatch(dateSearchAction({
            registerDateStart: registerDateStart,
            registerDateEnd: endDate
        }));
    }, [dispatch, registerDateStart]);

    return (
        <div className={"register_date"}>
            コメント登録日：
            <input type={"date"} value={registerDateStart} onChange={handleRegisterDateStart} />
            〜
            <input type={"date"} value={registerDateEnd} onChange={handleRegisterDateEnd} />
        </div>
    );
});